module.exports = __webpack_public_path__ + "static/media/lab_builder.dd0e1dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/lab_builder.png
// module id = 1066
// module chunks = 0